import React from 'react';
import { withProps, withHandlers, withState, compose, pure } from 'recompose';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  StyleLinkRead,
  StyledBoxOptions,
  StyledCredit,
  StyledDateNews,
  StyledMultimedia,
  StyledBoxNewText,
  StyledBoxNewsTab,
  StyledOptionsNews,
  StyledTagCategory,
  OverwriteDateFormat,
  LinkHeader,
  Strapline,
  StyledHeadline,
  StyledTruncateTitle
} from './style';

import { getImageLink } from '../../../utils/resources';
import Multimedia from '../Multimedia';
import WrapperShareSend from '../../core/OptionsNews/WrapperShareSend';

class NewsTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      likesNumberState: props.likesNumber
    };
  }

  onLikeHandler = id => {
    const { like, onLike } = this.props;
    const { likesNumberState } = this.state;
    const likesNumberStateUpdated = like
      ? likesNumberState - 1
      : likesNumberState + 1;

    this.setState({ likesNumberState: likesNumberStateUpdated });
    onLike(id);
  };

  getImageFormat = nameFile => {
    const regex = /(?:\.([^.]+))?$/;
    return regex.test(nameFile) && regex.exec(nameFile)[1];
  };

  render() {
    const {
      contentType,
      baseContentId,
      nameFile,
      link,
      title,
      author,
      mainTagName,
      mediaType,
      onToggleFullSize,
      image,
      videoNews,
      subtitle,
      orientation,
      onFavorite,
      onShare,
      onComment,
      favorite,
      like,
      share,
      numberOfComments,
      position,
      className,
      hastoken,
      dateFrom
    } = this.props;

    const { likesNumberState } = this.state;

    return (
      <StyledBoxNewsTab className={className}>
        <StyledMultimedia orientation={orientation}>
          <Multimedia
            media={mediaType}
            extFormat={this.getImageFormat(nameFile)}
            src={image || videoNews}
            onToggleFullSize={onToggleFullSize}
            home
          />
        </StyledMultimedia>

        <StyledBoxNewText
          orientation={orientation}
          share={share}
          className="NewsItem-box"
        >
          {mainTagName && <StyledTagCategory category={mainTagName} />}

          {dateFrom && (
            <StyledDateNews className="NewsItem-published">
              Publicado{' '}
              <OverwriteDateFormat fromNow>{dateFrom}</OverwriteDateFormat>
            </StyledDateNews>
          )}
          <StyledHeadline className="NewsItem-title">
            <LinkHeader to={link}>
              <StyledTruncateTitle
                maxlength={110}
                text={title}
                className="NewsItem-titleLink"
              />
            </LinkHeader>
          </StyledHeadline>

          {subtitle && position !== 'HIGHLIGHT' && (
            <Strapline
              text={subtitle}
              maxlength={400}
              className="NewsItem-description"
            />
          )}

          <StyleLinkRead to={link} title="leer más">
            + LEER MÁS
          </StyleLinkRead>

          <StyledBoxOptions className="NewsItem-boxOptions">
            <StyledCredit author={author} />
            <StyledOptionsNews
              numberIcon={numberOfComments}
              onLike={() => this.onLikeHandler(baseContentId)}
              onFavorite={() => onFavorite(baseContentId)}
              onShare={() => onShare(baseContentId)}
              onComment={onComment}
              activeLike={like}
              activeFavorite={favorite}
              isHome
              likesNumber={likesNumberState}
              hastoken={hastoken}
            />
          </StyledBoxOptions>
          {share && (
            <WrapperShareSend
              activeShare={share}
              onClose={onShare}
              baseContentId={baseContentId}
              contentType={contentType}
            />
          )}
        </StyledBoxNewText>
      </StyledBoxNewsTab>
    );
  }
}

NewsTab.propTypes = {
  contentType: PropTypes.string,
  baseContentId: PropTypes.string,
  nameFile: PropTypes.string,
  link: PropTypes.string,
  title: PropTypes.string,
  author: PropTypes.shape({}),
  mainTagName: PropTypes.string,
  mediaType: PropTypes.string,
  image: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  videoNews: PropTypes.shape({}),
  subtitle: PropTypes.string,
  orientation: PropTypes.string,
  onLike: PropTypes.func,
  onFavorite: PropTypes.func,
  onShare: PropTypes.func,
  onComment: PropTypes.func,
  favorite: PropTypes.bool,
  like: PropTypes.bool,
  share: PropTypes.bool,
  numberOfComments: PropTypes.number,
  position: PropTypes.string,
  className: PropTypes.string,
  hastoken: PropTypes.bool,
  dateFrom: PropTypes.instanceOf(Date)
};

export default withRouter(
  compose(
    withProps(
      ({
        baseContentId,
        clientPath,
        galleryImageClientPaths,
        mediaId,
        isWidget
        // title
      }) => ({
        // link: `/noticia/${baseContentId}/${title
        //   .replaceAll(' ', '_')
        //   .toLowerCase()}`,
        link:
          isWidget === true
            ? `/noticia/${baseContentId}?isWidget=${isWidget}`
            : `/noticia/${baseContentId}`,
        image:
          getImageLink(clientPath) ||
          (galleryImageClientPaths &&
            galleryImageClientPaths.map(image => getImageLink(image))),
        videoNews: mediaId && {
          // imgThumb: getImageVideoPath(video.imgPoster, 'default', nameFile),
          // imgPoster: getImageVideoPath(video.imgPoster, 'default', nameFile),
          id: mediaId,
          // duration: Math.floor(video.duration),
          tipo: 'VIDEO'
          // playondraw: false,
          // titulo: '',
          // sources: [
          //   {
          //     src: video.sources.hls,
          //     type: video.sources.type
          //   }
          // ]
        }
      })
    ),
    withState('share', 'setShare', false),
    withHandlers({
      onShare: ({ setShare, share }) => () => setShare(!share),
      onComment: ({ link, history }) => () => {
        history.push({ pathname: link, hash: 'comments' });
      },
      onToggleFullSize: ({ link, history }) => () => {
        history.push({ pathname: link });
      }
    }),
    pure
  )(NewsTab)
);
